module.exports = __webpack_public_path__ + "static/image_bg-957f113fb155e7237d065b0d06c1bea6.jpg";